import type { Chat } from '@mint-sdk/api-ai-assistant';

export const aiMetadataTemplates: Record<
  'aihub' | 'agentic',
  Chat.ChatDetailsQueryType
> = {
  aihub: {
    scopeType: 'PAGE',
    scopePath: 'ai-hub',
    entityType: null,
    entityId: null,
  },
  agentic: {
    scopeType: 'PAGE',
    scopePath: 'agentic',
    entityType: null,
    entityId: null,
  },
};
